import { FaLock } from 'react-icons/fa6'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import labelKey from '../../localization/label.json'
import { useReceiptVaultRules } from './useReceiptVaultRules'

type Props = {
  required?: boolean
  viewOnly?: boolean
  tooltipId?: string
  showTooltip?: boolean
}

const ReceiptDocumentLabel = ({
  required = false,
  viewOnly = false,
  tooltipId = 'receipt-doc-rules-tip',
  showTooltip = true,
}: Props) => {
  const { tooltipText } = useReceiptVaultRules(showTooltip)

  return (
    <>
      {showTooltip && (
        <Tooltip
          id={tooltipId}
          place="bottom-start"
          positionStrategy="fixed"
          className="ss-receipt-rules-tooltip"
          style={{
            maxWidth: 'min(420px, 85vw)',
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
            lineHeight: '1.45',
            textAlign: 'left',
            zIndex: 99999,
          }}
        />
      )}
      <div className="d-flex align-items-baseline">
        <label
          className={`d-flex align-items-center fs-5 fw-bold mb-2 ${required ? 'required' : ''}`}
        >
          {labelKey.receiptDocument}
          <i
            className="fa fa-info-circle ms-2 cursor-pointer text-primary"
            {...(showTooltip
              ? {
                  'data-tooltip-id': tooltipId,
                  'data-tooltip-content': tooltipText,
                }
              : {})}
            aria-label="Receipt upload rules and instructions"
          />
        </label>
        {viewOnly && <FaLock className="fs-7 ms-2 position-relative" />}
      </div>
    </>
  )
}

export default ReceiptDocumentLabel
